import React from 'react';
import { Navigate } from 'react-router-dom';

// ProtectedRoute to check if the user is logged in
const ProtectedRoute = ({ children, roleRequired  }) => {
  // Check if user session exists in localStorage
  const user = JSON.parse(localStorage.getItem('user')); // or use context/state

   // If user is not authenticated, redirect to the login page
  if (!user) {
    return <Navigate to="/" />;
  }
   // try to use token later instead if user with code below
    // const token = localStorage.getItem('token');
    // if (!token) {
    //   return <Navigate to="/login" />;
//const isAuthenticated = localStorage.getItem("userToken");
// if (!isAuthenticated) {
//   return <Navigate to="/login" />;

// Check if the user's role matches the required role
if (roleRequired && user.role !== roleRequired) {
  // If user is not authorized for this route, redirect to a forbidden page or a different route
  return <Navigate to="/" />;
}

  // If user is authenticated, render the protected content (children)
  return children;
};

export default ProtectedRoute;
// In this code snippet, we created a ProtectedRoute component that checks if the user is logged in. If the user is not logged in (i.e., the user session does not exist in localStorage), the component redirects the user to the login page. If the user is logged in, the component renders the protected content (children).